import { Navigate, useLocation } from "react-router-dom"
import useAuth from "helpers/useAuth"
 
const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  localStorage.setItem("locationPathname", location.pathname);

  return (
    <>
      {isAuthenticated ? (  
       children
     ) : (   
        <Navigate to={"/authentication/sign-in"} replace state={{ location }} />      
      )} 
    </>
  );
};
export default PrivateRoute;